import classNames from 'classnames'
import {
  SetInviteAuthorization,
  SetInviteAuthorizationVariables,
} from 'globalTypes'
import { map, toSafeInteger } from 'lodash'

import { useMutation } from '@apollo/client'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import styles from './index.module.css'
import MUTATION from './set-invite-authorization.graphql'

interface Props {
  elementId: string
  email: string
  level: number
}

const VALUES = {
  1: msg`Con permessi di lettura`,
  3: msg`Con permessi di gestione`,
}

const LevelButton = ({ elementId, level, email }: Props) => {
  const { _ } = useLingui()
  const [mutate] = useMutation<
    SetInviteAuthorization,
    SetInviteAuthorizationVariables
  >(MUTATION, {
    refetchQueries: ['GetElementAuthorizationForUsers'],
  })

  const onChange = ({ target }) =>
    mutate({
      variables: {
        elementId,
        email,
        value: toSafeInteger(target.value),
      },
    })

  return (
    <select
      className={classNames(styles.select, 'form-select')}
      defaultValue={level}
      onChange={onChange}
    >
      {map(VALUES, (name, value) => (
        <option key={value} value={value}>
          {_(name)}
        </option>
      ))}
    </select>
  )
}

export default LevelButton
